import HashIds from 'hashids';

const hashIds = new HashIds(
  process.env.REACT_APP_HASHID_SALT,
  12,
  '0123456789qwrtypsdfghjklzxcvbnmae',
);

export default hashIds;
